import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subjectDe", "subjectEn", "bodyDe", "bodyEn", "status"]
  static values = {
    url: String,
    errorMessage: String,
    appliedMessage: String,
    missingMessage: String
  }

  async apply(event) {
    const category = event.target.value

    this.clearStatus()
    if (!category) return

    event.target.disabled = true

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("category", category)
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      })

      if (response.status === 204) {
        this.clearFields()
        this.showStatus(this.missingMessageValue, "text-muted")
        return
      }
      if (!response.ok) throw new Error(`Template request failed with ${response.status}`)

      const template = await response.json()
      this.assign("subjectDe", template.contents_de)
      this.assign("subjectEn", template.contents_en)
      this.assign("bodyDe", template.body_de)
      this.assign("bodyEn", template.body_en)
      this.showStatus(this.appliedMessageValue, "text-success")
    } catch (error) {
      console.error(error)
      this.showStatus(this.errorMessageValue, "text-danger")
    } finally {
      event.target.disabled = false
    }
  }

  clearFields() {
    this.assign("subjectDe", "")
    this.assign("subjectEn", "")
    this.assign("bodyDe", "")
    this.assign("bodyEn", "")
  }

  assign(name, value) {
    const target = this[`${name}Target`]

    if (target.editor) {
      target.editor.loadHTML(value || "")
    } else {
      target.value = value || ""
      target.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  clearStatus() {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = ""
    this.statusTarget.classList.remove("text-success", "text-danger", "text-muted")
  }

  showStatus(message, className) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.classList.add(className)
  }
}
